/**
 * Registro del service worker.
 *
 * Es lo que convierte la web en algo instalable: sin un service worker con
 * manejador de `fetch`, Chrome no ofrece «Instalar aplicación» y en iOS la
 * pantalla de inicio abre una página que se queda en blanco sin cobertura.
 * Mientras iOS no tenga ficha en App Store, ése es el único camino que hay.
 *
 * Tres decisiones que conviene no deshacer sin pensarlas:
 *
 *   * **Sólo en producción y en vista previa.** En desarrollo, un service
 *     worker se queda sirviendo el bundle anterior y convierte cada cambio en
 *     una cacería: se edita un archivo, no pasa nada, y el rato siguiente se va
 *     en depurar código que el navegador ni siquiera está ejecutando.
 *   * **Después de `load`.** Registrarlo durante el arranque compite por el
 *     ancho de banda con el bundle que la persona está esperando.
 *   * **Un fallo no se propaga.** Si el navegador no lo admite —o el sitio se
 *     abre por HTTP, o el usuario bloqueó el almacenamiento— la aplicación
 *     funciona exactamente igual; lo único que pierde es poder instalarse.
 */

export function registerServiceWorker(): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  // `import.meta.env.DEV` lo sustituye Vite al compilar, así que esta rama
  // desaparece del bundle de producción.
  if (import.meta.env.DEV) return;

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch((error) => {
      // Informativo, no un error: no hay nada roto, sólo no habrá instalación.
      console.info('29100 Cloud: sin modo aplicación en este navegador', error);
    });
  });
}
